<template>
  <iframe
    class="w-full h-full"
    :src="`${currentEnv.VUE_APP_DATASEASE_PAGE}/#/panel/index?token=Bearer ${token}`"
    frameborder="0"
  ></iframe>
  <!-- 开发环境 http://localhost:9528/#/panel/index -->
  <!-- 测试环境 :src="`${currentEnv.VUE_APP_DATASEASE_PAGE}/#/panel/index`" -->
</template>
<script>
export default {
  data() {
    return {
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      token: Wiz.AuthHooks.GetToken(),
    }
  },
}
</script>
